// Bottom navigation bar, shared across guest screens. Three fixed tabs:
// the Map is home (everyone's positions + caches), Cases holds the dossier
// riddles, and Agent is the profile.
import { el } from "../lib/dom";
import { icon } from "./icons";

const ITEMS = [
  { path: "/map", ico: "map", label: "Map" },
  { path: "/cases", ico: "cases", label: "Cases" },
  { path: "/profile", ico: "agent", label: "Agent" },
];

export function nav(active: string): HTMLElement {
  return el(
    "nav.nav",
    {},
    ...ITEMS.map((it) =>
      el(
        `a${it.path === active ? ".active" : ""}`,
        { href: `#${it.path}` },
        icon(it.ico),
        el("span", {}, it.label),
      ),
    ),
  );
}
